import { render, staticRenderFns } from "./Signs.vue?vue&type=template&id=fce8d6e0"
import script from "./Signs.vue?vue&type=script&lang=ts"
export * from "./Signs.vue?vue&type=script&lang=ts"
import style0 from "./Signs.vue?vue&type=style&index=0&id=fce8d6e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports